import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0122',
    ecrans: ['00-2'],
    params: ['id', '?aplcod', '?indfor']
});
